import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ParCity from './par-city';
import ParCityDetail from './par-city-detail';
import ParCityUpdate from './par-city-update';
import ParCityDeleteDialog from './par-city-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ParCityUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ParCityUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ParCityDetail} />
      <ErrorBoundaryRoute path={match.url} component={ParCity} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ParCityDeleteDialog} />
  </>
);

export default Routes;
